import React from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './ClientLocations.css';
import maps from './maps.png'

// Example data
const data = [
    { name: 'Sydney', value: 65 },
    { name: 'Perth', value: 50 },
    { name: 'Melbourne', value: 40 },
    { name: 'Brisbane', value: 20 },
    { name: 'Darwin', value: 20 },
    { name: 'Gold Coast', value: 20 },
];

const geoUrl = "https://raw.githubusercontent.com/deldersveld/topojson/master/countries/australia/australia.json";

const ClientLocations = () => {
    return (
        <div className="client-locations">
            <h2>Client by locations</h2>
            <div className="conten">
                <img src={maps}></img>
                <div className="ma">
                    {/* <ComposableMap projection="geoMercator">
                        <Geographies geography={geoUrl}>
                            {({ geographies }) =>
                                geographies.map((geo) => (
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}
                                        fill={geo.properties.STATE_NAME === "New South Wales" ? "#4A90E2" : "#E0E0E0"}
                                        stroke="#FFFFFF"
                                    />
                                ))
                            }
                        </Geographies>
                        <Marker coordinates={[151.2093, -33.8688]}>
                            <circle r={5} fill="#4A90E2" />
                            <text textAnchor="middle" y={-10} style={{ fontSize: "10px" }}>Sydney</text>
                        </Marker>
                    </ComposableMap> */}
                </div>
                <div className="char">
                    <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={data} layout="vertical">
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" />
                            <YAxis type="category" dataKey="name" />
                            <Tooltip />
                            <Bar dataKey="value" fill="#4A90E2" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
};

export default ClientLocations;
